import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import ClientCompanyModel from "./models/ClientCompanyModel";
import ClientCompanyModal from "./ClientCompanyModal";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";

function ClientCompanyGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [clientCompanyModel, setClientCompanyModel] = useState(new ClientCompanyModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);

  function closeModal() {
    setIsOpen(false);
    props.fetchClientCompany();
  }
  
  const rows = props.ClientCompanyData
    ? props.ClientCompanyData.filter(
      (item) =>
        (item.ClientCompanyTypeName &&
          item.ClientCompanyTypeName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.ClientCompanyName &&
          item.ClientCompanyName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.Description && 
          item.Description.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.RMName1 && 
          item.RMName1.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.RMName2 && 
          item.RMName2.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.RMName3 && 
          item.RMName3.toLowerCase().includes(filterText.toLowerCase())) ||        
        (item.RMContact1 && 
          item.RMContact1.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.RMContact2 && 
          item.RMContact2.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.RMContact3 && 
          item.RMContact3.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    setClientCompanyModel(row);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    const clientCompanyModel = data;
    if (e.target.name === "Edit") {
      let clientCompanyDetails = {
        ClientCompanyId: clientCompanyModel.ClientCompanyId,
        ClientCompanyName: clientCompanyModel.ClientCompanyName,
        ClientCompanyTypeId: clientCompanyModel.ClientCompanyTypeId,
        Description: clientCompanyModel.Description,
        RMName1: clientCompanyModel.RMName1,
        RMContact1: clientCompanyModel.RMContact1,
        RMName2: clientCompanyModel.RMName2,
        RMContact2: clientCompanyModel.RMContact2,
        RMName3: clientCompanyModel.RMName3,
        RMContact3: clientCompanyModel.RMContact3,
        UserId: getStorageValues('userId')
      };
      if (validation(clientCompanyDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveClientCompanyDetails", 
            clientCompanyDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchClientCompany();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if(e.target.name === "Delete"){
      const clientCompanyModel = data;
      let clientCompanyDetails = {
        ClientCompanyId: clientCompanyModel.ClientCompanyId
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/deleteclientcompany", clientCompanyDetails
        );
        if (response.status === 200) {
          CreateAlert("Client company deleted successfully!!", "Success", setAlert);
          props.fetchClientCompany();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(clientCompanyDetails) {
    var validation = true;
    if (clientCompanyDetails) {
      if (clientCompanyDetails.ClientCompanyName !== null) {
        if (clientCompanyDetails.ClientCompanyName.length === 0) {
          CreateAlert("Please enter user name!!", "Warning", setAlert);
          validation = false;
          return;
        }
      } else {
        CreateAlert("Please enter user name!!", "Warning", setAlert);
        validation = false;
        return;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      validation = false;
      return;
    }
    return validation;
  }

  const columns = [
    {
      name: <div className="titlename"><span>Client Company Type</span></div>,
      selector: row => row.ClientCompanyTypeName,
      cell: (row) => (
        <span title={row.ClientCompanyTypeName}>{row.ClientCompanyTypeName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    {
      name:<div className="titlename"><span>Client Company</span></div> ,
      selector: row => row.ClientCompanyName,
      cell: (row) => (
        <span title={row.ClientCompanyName}>{row.ClientCompanyName}</span>
      ),
      sortable: true,
      sortIcon: <span > <SortArrow /></span>
    },
    
    {
      name: <div className="titlename"><span>Description </span></div>,
      selector: row => row.Description,
      cell: (row) => (
        <span title={row.Description}>{row.Description}</span>
      )
    },
 ];
 if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
 columns.push({
  
        name: <div className="titlename">Actions</div>,
        cell: (row) => (
          <div className="edit-delete-action">
            {
              props.UserPermissions.ViewModule === 1 ? 
                <Link
                  className="me-2 p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, "View");
                  }}
                >
                  <Icons.Eye data-feather="eye" className="action-eye" />
                </Link>
              : null
            }
            {
              props.UserPermissions.EditModule === 1 ? 
                <Link
                  className="me-2 p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, "Edit");
                  }}
                >
                  <Icons.Edit data-feather="edit" className="feather-edit" />
                </Link>
              : null
            }
            {
              props.UserPermissions.DeleteModule === 1 ? 
                <Link
                  className="confirm-text p-2"
                  to=""
                  onClick={() => {
                    openActionType(row, "Delete");
                  }}
                >
                  <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
                </Link>
              : null
            }
          </div>
        ),
        center: "true",
        width: "200px"
      },);
  
    }

 

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
      <ClientCompanyModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={clientCompanyModel}
        onSubmit={onSubmit}
      />
      
    </>
  );
}

export default ClientCompanyGrid;
